/* eslint-disable max-len */
import React, {
  useEffect, useState, useContext, useRef, useMemo,
} from 'react';
import { useHistory } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import ReportsPage from '../../pages/ReportsPages/ReportProviders/ReportsPage';
import reportsService from '../../services/reportsService';
import { ContextDownload } from '../../context/ContextDownload';

const ReportsContainer = () => {
  const [data, setData] = useState([]);
  const [zones, setZones] = useState([]);
  const [newFilter, setFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [csv, setCsv] = useState([]);
  const [loading2, setloasing2] = useState(false);

  const csvLink = useRef();

  const history = useHistory();
  const {
    updateCompany,
    updateSegment,
    updateCategory,
    setUpdateCategory,
  } = useContext(ContextDownload);

  const filterCategory = [];
  const filterSegment = [];

  /*= =======================================================================
  Get Categorys
====================================================== ================== */
  useEffect(() => {
    reportsService
      .getCategorys()
      .then((response) => {
        setUpdateCategory(response.data.data);
        if (response.data.data.length === 2) {
          setFilter([]);
        }
        if (response.data.data.length === 1) {
          setFilter(response.data.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (newFilter[0] == 'MOTOS COMBUSTION') {
      setFilter('CARGA Y PASAJEROS');
    }
    if (newFilter[0] == 'CARGA Y PASAJEROS') {
      setFilter('MOTOS COMBUSTION');
    }
  }, [newFilter]);

  /*= =======================================================================
  Get  Zone Providers Zone
====================================================== ================== */
  const getZones = (props) => {
    reportsService
      .postProviderZone(props)
      .then((response) => {
        setZones(response.data.data);
      })
      .catch((error) => {
        console.log(error);
        history.push('/login');
      });
  };

  /*= =======================================================================
  Get  Providers
====================================================== ================== */
  const handleSelectMonth = (props) => {
    setData([]);
    setLoading(true);
    reportsService
      .postPrivedersSegmentation(props)
      .then((response) => {
        setLoading(false);
        setData(response.data.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        history.push('/login');
      });
    getZones(props);
  };

  /*= =======================================================================
  Post CSV
====================================================== ================== */
  const handleOnSumit = (props) => {
    setloasing2(true);
    reportsService
      .postMotorciclesAnd3w(props)
      .then((response) => {
        if (response.data.data.length >= 1) {
          setCsv(response.data.data);
          csvLink.current.link.click();
          setloasing2(false);
        } else {
          swal({
            title: 'Upsss!',
            text: 'No results for selected filters',
            icon: 'warning',
            button: 'Cerrar!',
            dangerMode: true,
          });
          setloasing2(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setloasing2(false);
        console.log(error);
        // history.push('/login');
      });
  };
  /*= =======================================================================
  Normalizing information from selectors
====================================================== ================== */
  function removeDuplicates(value, index, array) {
    return array.indexOf(value) === index;
  }

  function removeDuplicates2(array) {
    const filter = array.filter((item, index) => array.indexOf(item) === index);
    return filter;
  }

  const filtered = useMemo(
    () => data.filter((element) => updateCompany.indexOf(element.EMPRESA) !== -1),
    [data, updateCompany],
  );

  const filtereSegmentPermissions = useMemo(
    () => data.filter((element) => updateCategory.indexOf(element.CATEGORY) !== -1),
    [data, updateCategory],
  );

  const filtereSubRegion = useMemo(
    () => zones.filter((element) => updateSegment.indexOf(element.REGION) !== -1),
    [zones, updateSegment],
  );

  const filteredCompany = data.map((obj) => obj.EMPRESA);

  const filteredBrand = filtered.length > 1
    ? filtered.map((obj) => obj.MARCA)
    : data.map((obj) => obj.MARCA);

  const filteredCategory = filtered.length > 1
    ? filtered.map((obj) => obj.CATEGORY)
    : data.map((obj) => obj.CATEGORY);

  const filteredSegment = filtereSegmentPermissions.map((obj) => obj.SEGMENT);

  const filteredRegion = zones.map((obj) => obj.REGION);

  const filteredSubRegion = filtereSubRegion.length > 1
    ? filtereSubRegion.map((obj) => obj.SUBREGION)
    : zones.map((obj) => obj.SUBREGION);

  filteredCategory.forEach((item, index) => {
    const p = removeDuplicates(item, index, filteredCategory);
    if (p && item !== null && item !== newFilter) {
      filterCategory.push(item);
    }
  });

  filteredSegment.forEach((item, index) => {
    const p = removeDuplicates(item, index, filteredSegment);
    if (p && item !== null && item) {
      filterSegment.push(item);
    }
  });

  const filterCompany = removeDuplicates2(filteredCompany);
  const filterBrand = removeDuplicates2(filteredBrand);
  const filterRegion = removeDuplicates2(filteredRegion);
  const filterSubRegion = removeDuplicates2(filteredSubRegion);

  return (
    <>
      <CSVLink
        filename="Lucia-Download.csv"
        data={csv}
        className="hidden"
        ref={csvLink}
        target="_blank"
      />
      <ReportsPage
        data={data}
        company={filterCompany}
        categoty={filterCategory}
        subRegion={filterSubRegion}
        region={filterRegion}
        brand={filterBrand}
        segment={filterSegment}
        loading={loading}
        loading2={loading2}
        zones={zones}
        onsubmit={handleOnSumit}
        onDateSelect={handleSelectMonth}
      />
    </>
  );
};

export default ReportsContainer;
